module.exports = __webpack_public_path__ + "static/media/sell_start_service_teach_7.b20512bc.jpg";